import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import CommonBubble from '@home/components/CommonBubble';
import './index.scss';

const TextBubbles = (props: any) => {
  const {
    text,
    /** 浮层单独内容；不传则与 `text` 一致（适合 `text` 为复杂节点时浮层仍展示纯文案） */
    tipContent,
    rowNum,
    placement,
    style,
    className,
    onClick,
    depend = '',
    closeOnScroll = false,
    bubbleProps,
  } = props;
  const TextDom = useRef(null);
  const [shouldShowBubble, setShouldShowBubble] = useState(false);
  const [windowSize, setWindowSize] = useState<any>(null);

  useEffect(() => {
    window.addEventListener('resize', () => setWindowSize(window.innerWidth));
    return () => {
      window.removeEventListener('resize', () =>
        setWindowSize?.(window.innerWidth),
      );
    };
  }, []);

  // 因为有响应式,所以要监听屏幕宽度， 重新判断高度
  useLayoutEffect(() => {
    if (TextDom.current) {
      const { offsetHeight, scrollHeight, offsetWidth, scrollWidth } =
        TextDom.current;
      setShouldShowBubble(
        offsetHeight < scrollHeight || offsetWidth < scrollWidth,
      );
    }
  }, [text, depend, windowSize]);

  const bubbleContent = tipContent !== undefined && tipContent !== null ? tipContent : text;

  return (
    <>
      {shouldShowBubble ? (
        <CommonBubble
          placement={placement ? placement : 'top'}
          dark
          content={bubbleContent}
          style={style ? style : {}}
          closeOnScroll={closeOnScroll}
          {...(bubbleProps || {})}
        >
          <div
            className={`${className ? className : ''} dbh-text-exceeds-bubble`}
            style={{
              WebkitLineClamp: rowNum ? rowNum : 1,
            }}
            ref={TextDom}
            onClick={() => {
              onClick?.();
            }}
          >
            {text}
          </div>
        </CommonBubble>
      ) : (
        <div
          className={`${className ? className : ''} dbh-text-exceeds-bubble`}
          style={{
            WebkitLineClamp: rowNum ? rowNum : 1,
          }}
          ref={TextDom}
          onClick={() => {
            onClick?.();
          }}
        >
          {text}
        </div>
      )}
    </>
  );
};

export default TextBubbles;
